import { FlowStepEditor } from "../FlowStepEditor";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { PropertyEditorTextList } from "../../../CommonUI/PropertyEditing/PropertyEditorTextList";
import React from "react";
import { LongOutputTestStep } from "../../../rule-engine-core/Flow/Steps/ExampleSteps/LongOutputTestStep";

export class LongOutputTestStepEditor extends FlowStepEditor<LongOutputTestStep> {
    renderEditUI(): JSX.Element | null {
        // todo: should not have to observe here
        return (
            <ObserveState
                listenTo={this}
                control={() => {
                    return (
                        <div>
                            <PropertyEditorTextList
                                editObject={this}
                                propertyName={"paths"}
                            />
                        </div>
                    );
                }}
            />
        );
    }
}
